export default __webpack_public_path__ + "static/media/slider-2.38ca8629.jpeg";